export const List = () => import("./List.vue");
export const DetailList = () => import("./DetailList.vue");
export const Result = () => import("./Result.vue");
export const Create = () => import("./Create.vue");
export const DetailEdit = () => import("./DetailEdit.vue");
export const DetailCreate = () => import("./DetailCreate.vue");
